module.exports = __webpack_public_path__ + "img/mainSlide-4.a523b67b.jpg";